var n = /* @__PURE__ */ ((r) => (r.primaryFont = "--THEME-font-primary", r.secondaryFont = "--THEME-font-secondary", r))(n || {});
export {
  n as FontRootNamesEnum
};
